import React, { Component, useState } from "react";
import { Form, Col, Button } from "react-bootstrap";
import $ from "jquery";
import Desplegable from "../../desplegable";
import { RRSSform } from "./rrss_form";

const FormLocalizacion = (props) => {

  const [rrss, setRrss] = useState(props.DatosProvincia.rrsses);

  // Función que hace el put a los datos personales de la monja
  const setInformacionOrganismo = async (event) => {
    event.preventDefault();
    //Formdata coge todo los elementos del formulario
    let myform = document.getElementById("MyForm");
    let form = new FormData(myform);
    form.append("RRSS", JSON.stringify(rrss));

    let settings = {
      url: process.env.REACT_APP_API_URL + "/provincias/" + props.DatosProvincia.id,
      method: "PUT",
      timeout: 0,
      xhrFields: {
        withCredentials: true,
      },
      processData: false,
      mimeType: "multipart/form-data",
      contentType: false,
      data: form,
    };

    // En caso de exito los asigna al estado del componente monja detalle
    await $.ajax(settings)
      .done(async function (response) {
        response = JSON.parse(response);
        props.setInformacionOrganismo(response);
        props.setAlert("", "Se han editado los datos correctamente", "success");
      })

      .fail(props.ErrorHandling);
  }

    return (
      <Form className=" p-4" onSubmit={setInformacionOrganismo} id="MyForm" autoComplete="off">
        <Form.Group>
          <Form.Row>
            <small className="mb-3">
              Los campos con un <b>*</b> deben de ser rellenados, incluso los del apartado de "Lugar de la Sede"
            </small>
          </Form.Row>
          <Desplegable
            Toogle={"Lugar de la Sede"}
            Text={
              <Col>
                <Form.Group>
                  <Form.Label>Dirección Postal *</Form.Label>
                  <Form.Control required type="text" name="addressHq" maxLength="100" autoComplete="nope" defaultValue={props.DatosProvincia.addressHq} />
                </Form.Group>
                <Form.Group>
                  <Form.Label>Telefono *</Form.Label>
                  <Form.Control required type="text" name="telephoneHq" maxLength="25" autoComplete="nope" defaultValue={props.DatosProvincia.telephoneHq} />
                </Form.Group>

                <Form.Group>
                  <Form.Label>Código Postal *</Form.Label>
                  <Form.Control required type="text" name="postcodeHq" maxLength="40" autoComplete="nope" defaultValue={props.DatosProvincia.postcodeHq} />
                </Form.Group>
                <Form.Group>
                  <Form.Label>País *</Form.Label>
                  <Form.Control required type="text" name="countryHq" maxLength="100" autoComplete="nope" defaultValue={props.DatosProvincia.countryHq} />
                </Form.Group>
                <Form.Group>
                  <Form.Label>Ciudad *</Form.Label>
                  <Form.Control required type="text" name="cityHq" maxLength="90" autoComplete="nope" defaultValue={props.DatosProvincia.cityHq} />
                </Form.Group>
              </Col>
            }
          />
          <Form.Label>Web Provincia</Form.Label>
          <Form.Control type="text" maxLength="100" name="web" autoComplete="nope" defaultValue={props.DatosProvincia.web} />
        </Form.Group>
        <Form.Group>
          <Form.Label>RRSS Provincia</Form.Label>
          <RRSSform rrss={rrss} setRRSS={setRrss}/>
        </Form.Group>


        <Form.Group>
          <Button
            type="submit"
            variant="outline-success"
            className="btn btn-block mt-5"
            //onClick={this.props.handleButtonShow} TODO cuando se le da a guardar no se cierra el modal
            name="Localizacion"
          >
            Guardar
          </Button>
        </Form.Group>
      </Form>
    );
}

export default FormLocalizacion;